import { createContext, PropsWithChildren, useCallback, useContext, useMemo, useState } from "react";

export interface IGlobalContex {

    gloader: string[];
    updateGLoading: (isLoading: boolean, loaderName: string) => void;

}

const defaultState = {} as IGlobalContex;
const GlobalContex = createContext<IGlobalContex>(defaultState);
export const useGlobalContext = (): IGlobalContex => useContext(GlobalContex);
const GlobalContextProvider = ({ children }: PropsWithChildren<{}>) => {
    const [gloader, setGLoader] = useState<string[]>([]);

    // Update loading state with callback to ensure state consistency
    const updateGLoading = useCallback((isLoading: boolean, loaderName: string) => {
        setGLoader((prevLoader) => {
            if (isLoading && !prevLoader.includes(loaderName)) {
                return [...prevLoader, loaderName];
            }
            if (!isLoading && prevLoader.includes(loaderName)) {
                return prevLoader.filter((item) => item !== loaderName);
            }
            return prevLoader;
        });
    }, []);

    const state = useMemo(
        () => ({
            gloader,
            updateGLoading,
        }),
        [gloader, updateGLoading]
    );
    return <GlobalContex.Provider value={state}>{children}</GlobalContex.Provider>;
};

export default GlobalContextProvider;